export default "/storefront/client/images/live-event-nuskin-mobile-logo.png";